import { createFileRoute, Outlet } from '@tanstack/react-router'

import { Spinner } from '@damis/ui/components/spinner'
import { requireSession } from '@/features/auth/require-session'

/**
 * Pathless layout for a page made to be printed or handed over (the customer summary): signed in
 * as `_app` is, but without the app's frame, so the page is only what it shows.
 */
export const Route = createFileRoute('/_print')({
  beforeLoad: ({ context, location }) => requireSession(context.queryClient, location.href),
  pendingComponent: () => (
    <div className="flex min-h-dvh items-center justify-center bg-background">
      <Spinner className="size-6 text-muted-foreground" />
    </div>
  ),
  component: () => (
    <div className="min-h-dvh bg-background text-foreground print:bg-white">
      <Outlet />
    </div>
  ),
})
